import styled from "styled-components";

export const StyledDataList = styled.datalist``;

export const StyledOption = styled.option``;